import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, removedResponse } from '../../../routes/defaultResponses';
import { surveyCommentTableSchema } from './surveyCommentTableSchema';

export const surveyCommentPaths = {
    '/api/surveys/{surveyId}/workflow/comments': {
        parameters: [createPathGuidParameter('surveyId')],
        post: {
            operationId: 'surveyCommentControllers.createWorkflowComment',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(surveyCommentTableSchema, ['text']),
                    },
                },
            },
            responses: { ...createdResponse },
        },
        get: {
            operationId: 'surveyCommentControllers.getWorkflowComments',
            responses: {
                200: {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(Type.Pick(surveyCommentTableSchema, ['id', 'text', 'commentedBy', 'commentedOn'])),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/comments': {
        parameters: [createPathGuidParameter('surveyId')],
        post: {
            operationId: 'surveySurveyCommentControllers.createComment',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(surveyCommentTableSchema, ['text']),
                    },
                },
            },
            responses: { ...createdResponse },
        },
        get: {
            operationId: 'surveySurveyCommentControllers.getComments',
            responses: {
                200: {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    ...Type.Pick(surveyCommentTableSchema, ['id', 'text', 'commentedBy', 'commentedOn']).properties,
                                    permissions: Type.Object({
                                        canDelete: Type.Boolean(),
                                    }),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/comments/{commentId}': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('commentId')],
        delete: {
            operationId: 'surveySurveyCommentControllers.delete',

            responses: { ...removedResponse },
        },
    },
} as const;
